import type { BankIdCertificate } from '../@types/BankIdCertificate';
import type { Actions } from '../actions';
import {
  RCV_CERTIFICATE_LIST,
  RCV_CREATE_CERTIFICATE,
  RCV_DELETE_CERTIFICATE,
  REQ_CERTIFICATE_LIST,
  REQ_CREATE_CERTIFICATE,
  REQ_DELETE_CERTIFICATE,
  REQUEST_FAILED,
} from '../actions/bankid';
import { requestStatus, responseStatus } from '../shared/statuses';

interface BankIdState {
  requestStatus: number;
  responseStatus: number;
  certificates: BankIdCertificate[];
}

export const initialState: BankIdState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  certificates: [],
};

const bankIdReducer = (state: BankIdState = initialState, action: Actions): BankIdState => {
  switch (action.type) {
    case REQ_CERTIFICATE_LIST:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING_LIST,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_CERTIFICATE_LIST:
      return {
        ...state,
        certificates: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_CREATE_CERTIFICATE:
      return {
        ...state,
        requestStatus: requestStatus.CREATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_CREATE_CERTIFICATE:
      return {
        ...state,
        certificates: state.certificates.concat([action.response]),
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_DELETE_CERTIFICATE:
      return {
        ...state,
        requestStatus: requestStatus.REMOVING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_DELETE_CERTIFICATE:
      return {
        ...state,
        certificates: state.certificates.filter((x) => x.thumbprint !== action.thumbprint),
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQUEST_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default bankIdReducer;
